import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-date-input',
  templateUrl: './date-input.component.html',
})
export class DateInputComponent {
  @Input() control!: AbstractControl;
  @Input() label = '';
  @Input() required = false;
  @Input() optional = false;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() serverError: string | null | undefined = '';
  @Input() id = '';
  @Input() placeholder = 'dd-mm-yyyy';
  @Input() min: string | null = null;
  @Input() max: string | null = null;

  @Output() keydown = new EventEmitter<KeyboardEvent>();

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get isInvalid(): boolean {
    return !!(this.submitted && this.control && this.control.invalid);
  }
}
